import {
  PositionType,
  TechStack,
  DashboardTempScoutProposal,
  StartupDetailForProposal,
  TrackingHireStatusInfo,
  AdminMatchingListChatStatus,
  TrackingHireStartupSimple,
  ScoutProfileDrafts,
  AdminFile,
  ScoutRequestFilterAssessment,
  AdminBrokingRequests,
  AdminBrokingRequestsConfirmed,
  AdminPreInterviewItem,
  ConditionForm,
} from 'types/common'
import {
  DEFAULT_MAX_DEV_COUNT,
  DEFAULT_MAX_MEMBER_COUNT,
} from 'infra/constants'

export const PositionMockData: PositionType[] = [
  {
    id: 1,
    name: '프론트엔드',
    isDeprecated: false,
    priority: 0,
    parentId: null,
  },
  { id: 2, name: '백엔드', isDeprecated: false, priority: 0, parentId: null },
  { id: 3, name: 'iOS', isDeprecated: false, priority: 0, parentId: null },
  { id: 4, name: 'Android', isDeprecated: false, priority: 0, parentId: null },
  {
    id: 5,
    name: 'RN/Flutter',
    isDeprecated: false,
    priority: 0,
    parentId: null,
  },
  { id: 6, name: 'DevOps', isDeprecated: false, priority: 0, parentId: null },
  { id: 7, name: 'AI/ML', isDeprecated: false, priority: 0, parentId: null },
  { id: 8, name: '데이터', isDeprecated: false, priority: 0, parentId: null },
  {
    id: 9,
    name: '게임 클라이언트',
    isDeprecated: false,
    priority: 0,
    parentId: null,
  },
  {
    id: 10,
    name: '게임 서버',
    isDeprecated: false,
    priority: 0,
    parentId: null,
  },
]

export const TechStackMockData: TechStack[] = [
  { id: 1, name: 'react' },
  { id: 2, name: 'next' },
  { id: 3, name: 'javascript' },
  { id: 4, name: 'css' },
  { id: 5, name: 'html' },
  { id: 6, name: 'nest' },
  { id: 7, name: 'styled-components' },
  { id: 8, name: 'typescript' },
  { id: 9, name: 'sass' },
  { id: 10, name: 'python' },
]

export const BannerMockData = [
  {
    id: 1,
    img: '/demo1.jpg',
    url: 'https://www.notion.so/API-3fdad9e49cde4849a8eb679ad39adeb0#2f7a686c5a3d4321a08c3bdf8323da6e',
  },
  {
    id: 2,
    img: '/demo2.jpg',
    url: 'https://www.notion.so/API-3fdad9e49cde4849a8eb679ad39adeb0#2f7a686c5a3d4321a08c3bdf8323da6e',
  },
  {
    id: 3,
    img: '/demo3.jpg',
    url: 'https://www.notion.so/API-3fdad9e49cde4849a8eb679ad39adeb0#2f7a686c5a3d4321a08c3bdf8323da6e',
  },
]

export const StartupPositionSimpleMockData = {
  id: 1,
  name: '웹 프론트',
  careerType: '신입',
  techStacks: ['React', 'Typescript', 'NextJS'],
  publishedAt: '2022-09-27',
  createdAt: '2022-10-22',
  isInterested: false,
}

export const StartupDetailMockData = {
  id: 1,
  name: '그룹바이',
  thumbnail:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhjQ6A0Q2xzfwbtxsG-l_gL2M6CULIJduQR9Wvk-TAbM4BPdRRRhvX-ND-EIlVZlFOacI&usqp=CAU',
  tags: ['시리즈A', '복지/혜택', '창업 3년 이하'],
  briefIntro: '안녕하세요 개발자 채용 플랫폼 그룹바이입니다.',
  fundingRound: '시리즈 A',
  accumulatedFunding: 11,
  recentFundingDate: '2022-02-01',
  memberCount: 20,
  devCount: 5,
  hasCto: true,
  effortForDev:
    '문서중심으로 커뮤니케이션하는 리뷰 외에 데일리미팅과 주간미팅도 진행해요! 데일리미팅에서는 서로 스쿼드에서 어떤 일을 하고 있는지 간략히 공유하고, 주간미팅에서는 각 스쿼드의 배포 일정에 대해 조율을 합니다.\n그리고, 주간미팅에서 각자 관심사에 대한 공유도 하고 있어요. 개발을 하면서 서비스와 전혀 관련 없는 요즘 공부하고 있는 것들, 요즘 유행하는 기술들에 대해서도 공유하는 자리도 있습니다.',
  solvingProblem:
    '"모바일 입력 경험"의 다양성이 점차 증가하는 상황에서 발생하는 키보드 경험의 문제를 해결합니다. 사람들의 모바일 입력 생산성을 향상시키고, 좋아하는 콘텐츠를 키보드에 담아 미소지을 수 있는 행복한 경험을 제공해요.',
  images: [
    'https://groupby.kr/_next/legacy/image?url=https%3A%2F%2Fraw.githubusercontent.com%2Fgroup-by-dev%2Fgroupby-operation%2Fmain%2Fstartup_data%2F%25EC%25A3%25BC%25EC%258B%259D%25ED%259A%258C%25EC%2582%25AC%25202%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589%2F2%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589_1.jpg%3Ftoken%3DGHSAT0AAAAAABX4MUK2GWZHGNQHWU5XPUYMYYRZB3A&w=1920&q=75',
    'https://groupby.kr/_next/legacy/image?url=https%3A%2F%2Fraw.githubusercontent.com%2Fgroup-by-dev%2Fgroupby-operation%2Fmain%2Fstartup_data%2F%25EC%25A3%25BC%25EC%258B%259D%25ED%259A%258C%25EC%2582%25AC%25202%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589%2F2%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589_1.jpg%3Ftoken%3DGHSAT0AAAAAABX4MUK2GWZHGNQHWU5XPUYMYYRZB3A&w=1920&q=75',
  ],
  howToStartup:
    '친구들과 함께 비트바이트라는 팀을 만들어 공모전에 나가 어플을 출시하고, 이를 계기로 창업을 하게되었습니다. 기술을 이용해 사람들의 일상을 가치있고 행복하게 만드는 서비스를 제공하고, 한 지역이나 국가가 아닌 만날 수 없는 범위의 전 세계 단위의 사람들에게 선보이기 위해 2018년 비트바이트를 창업했습니다.',
  whatKindCompany:
    '모바일 앱, 플레이키보드는요 \n기본 키보드와 동일한 사용 경험을 지향하며, 다양한 입력 편의 기능을 제공합니다\n    자주 쓰는 말: 주소, 연락처, 계좌번호 등 저장해두었다가 터치 한 번에 입력할 수 있어요.\n   클립보드: 복사한 내용을 한번에 확인하고 편리하게 붙여넣을 수 있어요.\n단축키 : ‘ㅋㅋㅋㅋ’ 처럼 치기 귀찮은 단어를 한 번에 입력해줘요.\n단어 추천 : 오타 걱정은 이제 그만! 가장 적당한 단어를 툴바에 추천해줘요.\nSNS 바로가기 : 툴바에 자주 사용하는 SNS 바로가기를 추가할 수 있어요.',
  pitch: 'ewi1ayuw3ew',
  pt: null,
  curOutcome:
    '“안 되면 되게 할 방법을 찾자” 안 된다고 생각하면 안될 이유는 너무 많습니다. 플레이키보드도 출시 전 주변에서 많은 혹평도 있었지만, 10대들의 니즈에 대한 확신이 있어서 출시를 강행하였고, 출시 후 60만 다운로드라는 성과를 이루게 되었습니다. 안되는 일을 되게하는게 스타트업이 해야하는 일이라고 생각합니다.',
  vision:
    '저희 팀은 매일 150개 국가에서 사용하는 글로벌 서비스 플레이키보드를 통해 실제로 사람들의 모바일 입력 생산성을 향상시키고, 좋아하는 콘텐츠를 키보드에 담아 미소지을 수 있는 행복한 경험을 제공하고 있어요. 그 범위는 샌프란시스코 인구의 2배보다 많고, 사람이 꽉 찬 서울 올림픽 주경기장을 29개 모은 수준인 230만 명이나 됩니다.',
  lookForDev:
    '플레이키보드는 팀 빌딩 중입니다. 회사와 지향하는 바를 공유하면서 함께 팀으로 일할 수 있는 분을 모시고자 합니다. 또한 플키팀이 지향하는 개발문화에 잘 녹아드실 수 있는 분을 찾습니다.',
  compensation:
    '현재 직원들의 연봉은 신입 3000만원 중반에서 시니어 7000만원 후반으로 분포가 되어있습니다. 능력에 따라서, 이정도 범위에서 연봉이 형성된다고 생각해주시면 됩니다.',
  welfare:
    '1. 생활\n• 분단위 시차출퇴근제(8:30~10:00/17:30~19:00)\n• 자유로운 복장, 연차사용\n• 야근식대 및 교통비 지원\n• 종합건강검진 지원\n• 국가건강검진 반차 지원\n• 경조사비 및 경조휴가 지원\n• 간식업체 운용\n• 명절선물 제공\n• 복지몰 운용\n• Tech직군: 맥북, 그램 + 피벗모니터 + 와이드모니터/일반직군: 그램, 울트라북 + 모니터 제공\n• 웰컴박스 제공 (텀블러, 후드집업, 슬리퍼, 노트커버, 굿즈 등)\n• 정부정책사업(휴가비지원사업, 청년내일채움공제, 중소기업소득세감면 등) 운용\n\n2. 교육\n• 외부 세미나 참석 지원\n• 외부 직무교육 강의 지원\n• 커리어 관련 도서 구매 지원',
  reasonForInvesting:
    '현재 직원들의 연봉은 신입 3000만원 중반에서 시니어 7000만원 후반으로 분포가 되어있습니다. 능력에 따라서, 이정도 범위에서 연봉이 형성된다고 생각해주시면 됩니다.',
  culture:
    '문서중심으로 커뮤니케이션하는 리뷰 외에 데일리미팅과 주간미팅도 진행해요! 데일리미팅에서는 서로 스쿼드에서 어떤 일을 하고 있는지 간략히 공유하고, 주간미팅에서는 각 스쿼드의 배포 일정에 대해 조율을 합니다.\n그리고, 주간미팅에서 각자 관심사에 대한 공유도 하고 있어요. 개발을 하면서 서비스와 전혀 관련 없는 요즘 공부하고 있는 것들, 요즘 유행하는 기술들에 대해서도 공유하는 자리도 있습니다.',
  members: [
    {
      id: 1,
      name: '임진하',
      role: 'CEO',
      career: 'http://url_link',
      intro: '안녕하세요, 그룹바이 임진하 대표입니다.',
    },
    {
      id: 2,
      name: '박상민',
      role: 'COO',
      career: 'http://url_link',
      intro: '그룹바이 귀여움 담당 박상민 입니다.',
    },
  ],
  location: '서울 강남',
  address: '테헤란로 2길 27 1023호',
  positions: [StartupPositionSimpleMockData],
  isInterested: false,
}

export const StartupMockData = {
  curr: {
    id: 1,
    name: '그룹바이',
    pitch: 'https://youtu.be/6q4DSKFn_k8',
    intro:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    culture:
      '문서중심으로 커뮤니케이션하는 리뷰 외에 데일리미팅과 주간미팅도 진행해요! 데일리미팅에서는 서로 스쿼드에서 어떤 일을 하고 있는지 간략히 공유하고, 주간미팅에서는 각 스쿼드의 배포 일정에 대해 조율을 합니다.\n그리고, 주간미팅에서 각자 관심사에 대한 공유도 하고 있어요. 개발을 하면서 서비스와 전혀 관련 없는 요즘 공부하고 있는 것들, 요즘 유행하는 기술들에 대해서도 공유하는 자리도 있습니다.',
    benefit:
      '1. 생활\n• 분단위 시차출퇴근제(8:30~10:00/17:30~19:00)\n• 자유로운 복장, 연차사용\n• 야근식대 및 교통비 지원\n• 종합건강검진 지원\n• 국가건강검진 반차 지원\n• 경조사비 및 경조휴가 지원\n• 간식업체 운용\n• 명절선물 제공\n• 복지몰 운용\n• Tech직군: 맥북, 그램 + 피벗모니터 + 와이드모니터/일반직군: 그램, 울트라북 + 모니터 제공\n• 웰컴박스 제공 (텀블러, 후드집업, 슬리퍼, 노트커버, 굿즈 등)\n• 정부정책사업(휴가비지원사업, 청년내일채움공제, 중소기업소득세감면 등) 운용\n\n2. 교육\n• 외부 세미나 참석 지원\n• 외부 직무교육 강의 지원\n• 커리어 관련 도서 구매 지원',
    pt: '',
    hasRequested: false,
    hasInterested: false,
    tags: ['시리즈A', '복지/혜택', '창업 3년 이하'],
    images: ['/demo1.jpg', '/demo2.jpg', '/demo3.jpg'],
    members: [
      {
        id: 1,
        name: '임진하',
        role: 'CEO',
        career: 'http://url_link',
        intro: '안녕하세요, 그룹바이 임진하 대표입니다.',
      },
      {
        id: 2,
        name: '박상민',
        role: 'COO',
        career: 'http://url_link',
        intro: '그룹바이 귀여움 담당 박상민 입니다.',
      },
    ],
    positions: [
      {
        id: 1,
        name: '웹 프론트',
        qualification:
          '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
        preferred:
          '• 학력: 초대졸이상\n• 경력: 2년 ~ 10년 이상\n• Next.js 프레임워크 개발 경험 필수',
        task: '• 이커머스 웹사이트 , APP backend 유지보수 및 고도화\n• 상품관리 시스템 보완 및 고도화 통한 운영 효율화\n• 정산시스템 효율화 및 자동화 \n• 주문처리 프로세스 모니터링 및 오류 수정  \n• 마케팅 관련 기능개발 및 최적화 : 광고 스크립트 및 설치, 이벤트 진행 관련 기능 개발\n*Tech Stack: https://stackshare.io/deleo/deleokorea',
        careerType: '신입',
        techStacks: ['React', 'Typescript', 'NextJS'],
      },
      {
        id: 2,
        name: '서버 백엔드',
        qualification: '점심메뉴 빠르게 잘 고르시는 분',
        preferred: '백엔드 개발 해보신 분',
        task: '· 웹 플랫폼 디자인 및 로직 개발, 유지/보수',
        careerType: '경력',
        techStacks: ['Django', 'MySQL', 'NodeJS'],
      },
    ],
  },
  prev: {
    id: 1,
    name: '그룹바이',
    briefIntro:
      '안녕하세요 우리는 스타트업의 개발자 채용의 어려움을 해결하는 GroupBy 입니다',
    thumbnail:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhjQ6A0Q2xzfwbtxsG-l_gL2M6CULIJduQR9Wvk-TAbM4BPdRRRhvX-ND-EIlVZlFOacI&usqp=CAU',
    hasPt: false,
    positions: ['iOS', 'Android', 'Unity', 'Backend'],
  },
  next: {
    id: 3,
    name: '삼성',
    briefIntro: "I'm SamSung.",
    thumbnail:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Samsung_Logo.svg/2560px-Samsung_Logo.svg.png',
    hasPt: true,
    positions: ['iOS', 'Android', 'Unity', 'Backend'],
  },
}

export const ApplyMockData = {
  email: 'hello_world@grouby.biz',
  phone: '01024272944',
  files: [],
  links: [
    'https://www.notion.so/API-3fdad9e49cde4849a8eb679ad39adeb0#de6d1434df86424da20bb3be9a5eecc3',
    'https://www.notion.so/6424da20bb3be9a5eecc3',
  ],
  coverLetter:
    '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
}

export const ApplicationsMockData = [
  {
    startup: { id: 1, name: '그룹바이' },
    position: { name: '백엔드', careerType: '신입' },
    appliedAt: '2022-08-10',
    email: 'us03184@gmail.com',
    phone: '01022228888',
    files: [],
    links: ['http://github.co.kr', 'http://notion.kr'],
    coverLetter:
      '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
  },
  {
    startup: { id: 19, name: '원티드' },
    position: { name: '프론트엔드', careerType: '경력' },
    appliedAt: '2022-08-11',
    email: 'us03184@gmail.com',
    phone: '01022228888',
    files: [],
    links: ['http://github.co.kr', 'http://notion.kr'],
    coverLetter:
      '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
  },
]

export const DashboardApplicationsMockData = {
  total: 10,
  items: [
    {
      id: 132,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us031ddjtjgdddddd84@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: true,
    },
    {
      id: 13,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: true,
    },
    {
      id: 12,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 2,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 1,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 1323,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us031ddjtjgdddddd84@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 18,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 127,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 24,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
    {
      id: 71,
      user: { id: 2, name: '전슬기', experience: 1 },
      position: {
        careerType: '신입',
        name: '프론트엔드',
      },
      appliedAt: '2022-09-01',
      email: 'us03184@gmail.com',
      phone: '01022228888',
      coverLetter:
        '성장과정 및 가치관 학교가 끝난 후 집으로 바로 가지 않고 부모님이 계신 슈퍼마켓으로 향하곤 했습니다.\n 동네에서 작은 슈퍼마켓을 운영하던 부모님의 일손을 덜어드리기 위해 어릴 적부터 가게의 카운터를 보고 매장 재고관리, 청소 등 허드렛일을 도맡아 했습니다.\n 손님들의 눈에 아마도 저의 모습 저의 강점인 ‘성실함’과 ‘부지런함’으로 매사에 임하고자 합니다.\n 저에게 주어진 일 만큼은 책임감을 가지고 실수 없이 처리할 것입니다.\n 무엇보다 저의 강점인 친화력을 발휘해 여러',
      files: [],
      links: ['http://github.co.kr', 'http://notion.kr'],
      isBookmarked: false,
    },
  ],
}

export const DashboardStatusMockData = [
  {
    id: 1,
    name: '지원자',
    count: 5,
  },
  {
    id: 2,
    name: '서류 합격',
    count: 4,
  },
  {
    id: 3,
    name: '최종 합격',
    count: 2,
  },
  {
    id: 4,
    name: '불합격',
    count: 5,
  },
]

export const DashboardPositionsMockData = [
  {
    id: 1,
    name: '프론트엔드 개발자',
    positionType: { id: 1, name: '프론트엔드' },
    careerType: { id: 1, name: '신입' },
    techStacks: [{ id: 1, name: 'React' }],
    task: '<p>• Cloud 환경에 익숙하신 분 • 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분 • REST API 및 MSA 경험 또는 관심 있으신 분 • 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 • Frontend 개발 경험이나 관심이 있으신 분 • Elastic search 개발 또는 연동 경험 있으신 분</p>',
    qualification:
      '<p>• Cloud 환경에 익숙하신 분 • 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분 • REST API 및 MSA 경험 또는 관심 있으신 분 • 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 • Frontend 개발 경험이나 관심이 있으신 분 • Elastic search 개발 또는 연동 경험 있으신 분</p>',
    preferred:
      '<p>• Cloud 환경에 익숙하신 분 • 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분 • REST API 및 MSA 경험 또는 관심 있으신 분 • 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 • Frontend 개발 경험이나 관심이 있으신 분 • Elastic search 개발 또는 연동 경험 있으신 분</p>',
    isPublished: true,
    publishedAt: '2022-09-13',
    applicationCount: 24,
    createdAt: '2022-09-13',
  },
  {
    id: 2,
    name: '서버개발자',
    positionType: { id: 2, name: '백엔드' },
    careerType: { id: 2, name: '경력' },
    techStacks: [{ id: 1, name: 'Javascript' }],
    task: '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    qualification:
      '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    preferred:
      '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    isPublished: false,
    publishedAt: null,
    applicationCount: 10,
    createdAt: '2022-09-13',
  },
  {
    id: 3,
    name: '머신러닝 엔지니어',
    positionType: { id: 3, name: '데이터 엔지니어' },
    careerType: { id: 3, name: '무관' },
    techStacks: [{ id: 1, name: 'MySQL' }],
    task: '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    qualification:
      '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    preferred:
      '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
    isPublished: true,
    publishedAt: '2022-09-13',
    applicationCount: 29,
    createdAt: '2022-09-13',
  },
]

export const DashboardStartupMockData = {
  pitch: 'https://youtu.be/6q4DSKFn_k8',
  pt: 'https://youtu.be/6q4DSKFn_k8',
  thumbnail:
    'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%202%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89/2%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89_%EC%8D%B8%EB%84%A4%EC%9D%BC.png?token=GHSAT0AAAAAABX4MUK3UUFC5BYD6UDMFRUQYYRZDMQ',
  name: '그룹바이',
  briefIntro:
    '스타트업을 위한 개발자 채용 플랫폼을 만들어가고 있는 그룹바이입니다.',
  tags: ['성장', '간식', '시리즈a', '공유오피스', '식비지원', '스톡옵션'],
  intro:
    '<p><span style="color: rgb(20, 20, 20);">스타트업은 어디서 개발자 채용하지?”</span></p><p><span style="color: rgb(20, 20, 20);">기존의 채용 서비스들은 평균적으로 최소 20인 이상 규모의 기업들에게 집중하고 있습니다. 이제 막 초기 투자를 받은 초기 스타트업들은 원티드, 프로그래머스와 같은 채용 플랫폼의 서비스를 이용하더라도 성공적인 채용이 진행되지 않는 것이 현실입니다.</span></p>',
  images: [
    'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%20%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%EC%97%90%EC%9D%B4%EC%B9%98%EC%95%8C/%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%201.png?token=GHSAT0AAAAAABX4MUK3EWML5QVQH3ZYFRK6YYRZMYQ',
  ],
  culture:
    '<ul><li><span style="color: rgb(20, 20, 20);">자유로운 재택근무 문화</span></li><li><span style="color: rgb(20, 20, 20);">월 2회 OFF DAY(월차) 사용 가능</span></li><li><span style="color: rgb(20, 20, 20);">오전 10시 ~ 오후 5시 + 1시간 자율출퇴근 제도 (점심시간 1시간 30분)</span></li><li><span style="color: rgb(20, 20, 20);">맥북 프로, 모니터, 키보드 등 개발 장비 지원 (요청시 다른 기종 가능)</span></li><li><span style="color: rgb(20, 20, 20);">성장지원비 무제한 지원</span></li></ul>',
  members: [
    {
      id: 12,
      name: '임진하',
      role: 'CEO',
      career: 'https://www.instagram.com/daily_groupby',
      intro: 'ddd',
    },
  ],
  benefit:
    '<ol><li><span style="color: rgb(20, 20, 20);">혼자는 외로워..  페어코딩 환경</span></li><li class="ql-indent-1"><span style="color: rgb(20, 20, 20);">두명 이상의 개발자가 하나의 코드를 리뷰하고, 함께 개발하는 문화</span></li><li class="ql-indent-1"><span style="color: rgb(20, 20, 20);">이를 위해 현재 프론트엔드 개발자 2명, 백엔드 개발자 2명이 근무를 하고 있습니다.</span></li><li><span style="color: rgb(20, 20, 20);">나는 왜 개발을 하는거지? OKR 기반 목표설정</span></li><li class="ql-indent-1"><span style="color: rgb(20, 20, 20);">회사 전체의 상위목표로 부터 각 팀의 목표가 명확하게 정해집니다.</span></li><li class="ql-indent-1"><span style="color: rgb(20, 20, 20);">내가 어떤 일을 해야하고, 어떤 지표에 집중해야하는지 모든 팀원이 인지하고 있습니다. </span></li></ol>',
  isPublished: true,
  publishedAt: '2022-09-11',
}

// NOTE(JUNSEULGI): 이미 작성한 정보 없을 때 받을 값(회원가입 직후)
export const EmptyDashboardStartupMockData = {
  pitch: '',
  pt: '',
  thumbnail: '',
  name: '',
  briefIntro: '',
  tags: [],
  intro: '',
  images: [],
  culture: '',
  members: [],
  benefit: '',
  isPublished: false,
  publishedAt: '',
}

export const StartupPositionMockData = {
  id: 1,
  name: '웹 프론트',
  careerType: '신입',
  techStacks: ['React', 'Typescript', 'NextJS'],
  publishedAt: '2022.10.21',
  createdAt: '2022.10.18',
  isInterested: false,
  startup: {
    id: 3,
    name: '그룹바이',
    thumbnail:
      'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%202%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89/2%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89_%EC%8D%B8%EB%84%A4%EC%9D%BC.png?token=GHSAT0AAAAAABX4MUK3UUFC5BYD6UDMFRUQYYRZDMQ',
    tags: ['성장', '간식', '시리즈a', '공유오피스', '식비지원', '스톡옵션'],
    briefIntro:
      '스타트업을 위한 개발자 채용 플랫폼을 만들어가고 있는 그룹바이입니다.',
    location: '서울 강남',
    memberCount: 10,
    devCount: 5,
    pt: 'https://youtu.be/baa4fqPKF3A',
    // pt: '',
    pitch: 'https://youtu.be/6q4DSKFn_k8',
  },
}

export const PositionDetailMockData = {
  id: 1,
  name: '웹 프론트',
  careerType: '신입',
  techStacks: ['React', 'Typescript', 'NextJS'],
  publishedAt: '2022.10.21',
  createdAt: '2022.10.18',
  isInterested: false,
  task: '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
  qualification:
    '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',
  preferred:
    '• Cloud 환경에 익숙하신 분\n• 최신 PHP 트렌드 및 CI/CD에 관심 있으신 분\n• REST API 및 MSA 경험 또는 관심 있으신 분\n• 각종 Laravel 패키지,콤포넌트 개발 또는 경험이 있으신 분 \n• Frontend 개발 경험이나 관심이 있으신 분\n• Elastic search 개발 또는 연동 경험 있으신 분',

  startup: {
    id: 3,
    name: '그룹바이',
    thumbnail:
      'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%202%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89/2%EC%9B%94%EB%8C%80%EA%B0%9C%EB%B4%89_%EC%8D%B8%EB%84%A4%EC%9D%BC.png?token=GHSAT0AAAAAABX4MUK3UUFC5BYD6UDMFRUQYYRZDMQ',
    tags: ['성장', '간식', '시리즈a', '공유오피스', '식비지원', '스톡옵션'],
    briefIntro:
      '스타트업을 위한 개발자 채용 플랫폼을 만들어가고 있는 그룹바이입니다.',
    location: '서울 강남',
    memberCount: 10,
    devCount: 5,
    pt: 'https://youtu.be/baa4fqPKF3A',
    // pt: '',
    pitch: 'https://youtu.be/6q4DSKFn_k8',
  },
}

export const RequestFormOptionsMockData = {
  locations: [
    { id: 1, name: '강남', priority: 11, isSeoul: true, isRemote: false },
    { id: 2, name: '서초', priority: 10, isSeoul: true, isRemote: false },
    { id: 3, name: '마포', priority: 9, isSeoul: true, isRemote: false },
    { id: 4, name: '관악', priority: 8, isSeoul: true, isRemote: false },
    { id: 5, name: '가산디지털', priority: 7, isSeoul: true, isRemote: false },
    { id: 6, name: '구로디지털', priority: 6, isSeoul: true, isRemote: false },
    { id: 7, name: '서울', priority: 5, isSeoul: false, isRemote: false },
    { id: 8, name: '분당/판교', priority: 4, isSeoul: false, isRemote: false },
    { id: 9, name: '경기', priority: 3, isSeoul: false, isRemote: false },
    { id: 10, name: '인천', priority: 2, isSeoul: false, isRemote: false },
    { id: 11, name: '대전', priority: 1, isSeoul: false, isRemote: false },
    { id: 12, name: '부산', priority: 0, isSeoul: false, isRemote: false },
    { id: 13, name: '재택근무', priority: 12, isSeoul: false, isRemote: true },
  ],
  serviceAreas: [
    { id: 1, name: '홈테크' },
    { id: 2, name: '환경' },
    { id: 3, name: '제조' },
    { id: 4, name: '패션/뷰티' },
    { id: 5, name: '게임' },
    { id: 6, name: '바이오/의료' },
    { id: 7, name: '교육' },
    { id: 8, name: '금융' },
    { id: 9, name: '헬스케어' },
    { id: 10, name: '보안' },
    { id: 11, name: 'AI' },
    { id: 12, name: '유아' },
    { id: 13, name: '마케팅' },
    { id: 14, name: '홈테크' },
    { id: 15, name: '환경' },
    { id: 16, name: '제조' },
    { id: 17, name: '패션/뷰티' },
    { id: 18, name: '게임' },
    { id: 19, name: '바이오/의료' },
    { id: 20, name: '교육' },
    { id: 21, name: '금융' },
    { id: 22, name: '헬스케어' },
    { id: 23, name: '보안' },
    { id: 24, name: 'AI' },
    { id: 25, name: '유아' },
    { id: 26, name: '마케팅' },
  ],
  fundingRounds: [
    {
      id: 1,
      name: 'Seed',
      devScoutDesc: '이제 막 설립된 회사의 초기 멤버로 제안받고 싶어요',
    },
    {
      id: 2,
      name: 'Pre-A',
      devScoutDesc:
        '안정적인 자금과 확실한 개발 동료가 있는 회사의 제안을 받고싶어요 ',
    },
    {
      id: 3,
      name: 'Series A',
      devScoutDesc: '개발 문화가 안정된, 규모 있는 회사의 제안을 받고싶어요',
    },
  ],
  educationStatus: [
    { id: 1, name: '재학' },
    { id: 2, name: '휴학' },
    { id: 3, name: '졸업 예정' },
    { id: 4, name: '졸업' },
    { id: 5, name: '중퇴' },
  ],
}

export const ScoutProfileDraftMockData: ScoutProfileDrafts | null = {
  expectations: ['Hoping to take on more leadership roles in technology.'],
  introductions: [
    'A software engineer with a passion for solving complex problems.',
  ],
  jobSearchingReasons: ['Looking for new challenges in tech.'],
  careers: [
    {
      id: 2,
      company: {
        id: 2,
        name: 'Startup XYZ',
        isStartup: true,
        image: null,
        isCreatedByUser: true,
      },
      link: 'https://startupxyz.com',
      position: 'Frontend Developer',
      started: '2018-01',
      ended: '2019-06',
      isWorking: false,
      techStacks: [
        { id: 1, name: 'JavaScript' },
        { id: 2, name: 'React' },
      ],
      serviceAreas: [{ id: 2, name: 'Frontend Development', parentId: 1 }],
      description:
        "Built and maintained the frontend of the company's main product.",
      isVerified: true,
    },
    {
      id: 3,
      company: {
        id: 4,
        name: 'GroupBy',
        isStartup: true,
        image: null,
        isCreatedByUser: true,
      },
      link: 'https://startupxyz.com',
      position: 'Frontend Developer',
      started: '2018-01',
      ended: '2019-06',
      isWorking: false,
      techStacks: [
        { id: 1, name: 'JavaScript' },
        { id: 2, name: 'React' },
      ],
      serviceAreas: [{ id: 2, name: 'Frontend Development', parentId: 1 }],
      description:
        "Built and maintained the frontend of the company's main product.",
      isVerified: true,
    },
  ],
  educations: [
    {
      id: 1,
      status: { id: 1, name: 'Graduated' },
      isCs: true,
      major: 'Computer Science',
      category: { id: 2, name: 'Engineering' },
      admissionYear: '2015',
      graduationYear: '2019',
      school: { id: 3, name: 'Stanford University', image: null, groups: [] },
      isCreatedByUser: true,
      isCompleted: true,
      isEdited: false,
    },
    {
      id: 2,
      status: { id: 1, name: 'Graduated' },
      isCs: true,
      major: 'Computer Science',
      category: { id: 2, name: 'Engineering' },
      admissionYear: '2015',
      graduationYear: '2019',
      school: { id: 3, name: 'Stanford University', image: null, groups: [] },
      isCreatedByUser: true,
      isCompleted: true,
      isEdited: false,
    },
  ],
  languageSkills: [
    {
      id: 1,
      language: { id: 1, name: 'English' },
      level: { id: 2, name: 'Fluent' },
      description: 'Fluent in both written and spoken English.',
    },
  ],
  otherActivities: [
    {
      id: 1,
      title: 'Open Source Contributor',
      description: 'Contributed to various open source projects on GitHub.',
      started: '2020-01',
      ended: '2022-12',
      techStacks: [{ id: 3, name: 'Python' }],
      isOnGoing: false,
    },
  ],
}

export const StartupChatListMockData = [
  {
    proposalId: 56,
    requestId: 366,
    startupId: 25,
    name: '전슬기',
    proposedAt: '2022-12-30 11:39:22',
    unreadMessageCount: 0,
    lastMessage: {
      type: 'chat.message.write',
      proposalId: 56,
      messageId: 13,
      startupId: 25,
      userId: null,
      sentAt: '2022-12-31 17:13:22',
      readAt: null,
    },
  },
]

export const DashboardTempScoutProposalDetailMockData: DashboardTempScoutProposal =
  {
    appealPoints: '기업 어필 포인트',
    fulfillments: [
      { dataKey: 'locations', description: '위치 조건에 대한 부가설명' },
    ],
    introPerson: '제안자 소개',
    outro: '끝맺음 인사',
    positions: [171],
    proposeReason: '제안한 이유',
    isResumeRequest: true,
  }

export const StartupDetailForProposalMockData: StartupDetailForProposal = {
  id: 12,
  name: '그룹바이',
  briefIntro:
    '스타트업을 위한 인재 채용 플랫폼을 만들어가고 있는 그룹바이입니다.',
  thumbnail:
    'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%20%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%EC%97%90%EC%9D%B4%EC%B9%98%EC%95%8C/%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%201.png?token=GHSAT0AAAAAABX4MUK3EWML5QVQH3ZYFRK6YYRZMYQ',
  serviceAreas: [],
  fundings: [
    {
      id: 1,
      round: 'Series A',
      amount: 200000, // 2억원
      attractedAt: '2026-03',
    },
    {
      id: 2,
      round: 'Pre-A',
      amount: 0,
      attractedAt: '2024-06',
    },
    {
      id: 3,
      round: 'Seed',
      amount: 30000, // 3천만원
      attractedAt: '2022-05',
    },
  ],
  memberCount: 20,
  devCount: 5,
  hasCto: true,
  whatKindCompany:
    '모바일 앱, 플레이키보드는요 \n기본 키보드와 동일한 사용 경험을 지향하며, 다양한 입력 편의 기능을 제공합니다\n    자주 쓰는 말: 주소, 연락처, 계좌번호 등 저장해두었다가 터치 한 번에 입력할 수 있어요.\n   클립보드: 복사한 내용을 한번에 확인하고 편리하게 붙여넣을 수 있어요.\n단축키 : ‘ㅋㅋㅋㅋ’ 처럼 치기 귀찮은 단어를 한 번에 입력해줘요.\n단어 추천 : 오타 걱정은 이제 그만! 가장 적당한 단어를 툴바에 추천해줘요.\nSNS 바로가기 : 툴바에 자주 사용하는 SNS 바로가기를 추가할 수 있어요.',
  curOutcome:
    '“안 되면 되게 할 방법을 찾자” 안 된다고 생각하면 안될 이유는 너무 많습니다. 플레이키보드도 출시 전 주변에서 많은 혹평도 있었지만, 10대들의 니즈에 대한 확신이 있어서 출시를 강행하였고, 출시 후 60만 다운로드라는 성과를 이루게 되었습니다. 안되는 일을 되게하는게 스타트업이 해야하는 일이라고 생각합니다.',
  images: [
    'https://groupby.kr/_next/legacy/image?url=https%3A%2F%2Fraw.githubusercontent.com%2Fgroup-by-dev%2Fgroupby-operation%2Fmain%2Fstartup_data%2F%25EC%25A3%25BC%25EC%258B%259D%25ED%259A%258C%25EC%2582%25AC%25202%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589%2F2%25EC%259B%2594%25EB%258C%2580%25EA%25B0%259C%25EB%25B4%2589_1.jpg%3Ftoken%3DGHSAT0AAAAAABX4MUK2GWZHGNQHWU5XPUYMYYRZB3A&w=1920&q=75',
    'https://raw.githubusercontent.com/group-by-dev/groupby-operation/main/startup_data/%EC%A3%BC%EC%8B%9D%ED%9A%8C%EC%82%AC%20%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%EC%97%90%EC%9D%B4%EC%B9%98%EC%95%8C/%EA%B7%B8%EB%A3%B9%EB%B0%94%EC%9D%B4%201.png?token=GHSAT0AAAAAABX4MUK3EWML5QVQH3ZYFRK6YYRZMYQ',
  ],
  members: [
    {
      id: 1,
      name: '임진하',
      role: 'CEO',
      career: 'http://url_link',
      intro: '안녕하세요, 그룹바이 임진하 대표입니다.',
    },
    {
      id: 2,
      name: '박상민',
      role: 'COO',
      career: 'http://url_link',
      intro: '그룹바이 귀여움 담당 박상민 입니다.',
    },
  ],
  reasonForInvesting:
    '현재 직원들의 연봉은 신입 3000만원 중반에서 시니어 7000만원 후반으로 분포가 되어있습니다. 능력에 따라서, 이정도 범위에서 연봉이 형성된다고 생각해주시면 됩니다.',
}

export const StartupDetailForProposalExample: StartupDetailForProposal = {
  id: 0,
  name: '',
  thumbnail: '',
  briefIntro: '',
  serviceAreas: [],
  fundings: [],
  memberCount: 20,
  devCount: 12,
  hasCto: true,
  whatKindCompany: '',
  curOutcome: '',
  members: [],
  reasonForInvesting: '',
  images: [],
}

export const ConditionFormExample: ConditionForm = {
  workLevel: 3,
  jobInterestLevel: null,
  isActivelySeeker: true,
  locations: [
    { id: 3, name: '마포구', parentId: 7 },
    { id: 1, name: '강남구', parentId: 7 },
    { id: 35, name: '용산구', parentId: 7 },
  ],
  serviceAreas: [],
  fundingRounds: [2, 3],
  memberCount: {
    min: 10,
    max: DEFAULT_MAX_MEMBER_COUNT,
  },
  devCount: {
    min: 0,
    max: DEFAULT_MAX_DEV_COUNT,
  },
  salary: {
    min: 4800,
    max: 10000,
  },
  miscOptions: {
    shouldCto: false,
    shouldSupervisor: true,
    shouldStockOption: true,
    remoteWorkPreference: null,
    isSalaryNegotiableWithStockOption: false,
  },
  requiredConditions: [
    {
      dataKey: 'fundingRounds',
      isRequired: true,
    },
    {
      dataKey: 'locations',
      isRequired: true,
    },
    {
      dataKey: 'shouldSupervisor',
      isRequired: true,
    },
  ],
  lastSavedStep: 0,
}

export const RequestDetailExampleForGreeting: ConditionForm = {
  workLevel: 3,
  jobInterestLevel: null,
  isActivelySeeker: true,
  locations: [
    { id: 3, name: '마포구', parentId: 7 },
    { id: 1, name: '강남구', parentId: 7 },
    { id: 35, name: '용산구', parentId: 7 },
  ],
  serviceAreas: [93, 29, 32],
  fundingRounds: [1, 2],
  memberCount: {
    min: 8,
    max: DEFAULT_MAX_MEMBER_COUNT,
  },
  devCount: {
    min: 0,
    max: DEFAULT_MAX_DEV_COUNT,
  },
  salary: {
    min: 4000,
    max: 10000,
  },
  miscOptions: {
    shouldCto: false,
    shouldSupervisor: true,
    shouldStockOption: true,
    remoteWorkPreference: null,
    isSalaryNegotiableWithStockOption: false,
  },
  requiredConditions: [
    {
      dataKey: 'fundingRounds',
      isRequired: true,
    },
    {
      dataKey: 'locations',
      isRequired: true,
    },
    {
      dataKey: 'shouldSupervisor',
      isRequired: true,
    },
  ],
  lastSavedStep: 0,
}

export const ProposalExampleForGreeting: DashboardTempScoutProposal = {
  fulfillments: [
    {
      dataKey: 'memberCount',
      description:
        '현재 10명의 팀원으로 구성되어 있으며, 4개월 내로 5명을 추가 채용할 계획입니다.',
    },
    {
      dataKey: 'locations',
      description:
        '출근하실 사무실은 강남 테헤란로에 위치하여, 교통이 편리합니다.',
    },
    {
      dataKey: 'fundingRounds',
      description:
        '22년 5월 Seed 투자 유치 및 Tips 선정을 통해 자본금 약 10억으로 시작했으며, 추가 10억 투자 유치를 곧 완료할 예정입니다.',
    },
    {
      dataKey: 'salary',
      description:
        '제시하신 연봉은 충분히 지급 가능하며, 추후 미팅을 통해 상세히 이야기 나누고 싶습니다.',
    },
    {
      dataKey: 'shouldSupervisor',
      description:
        '스타트업 극초기 멤버로 합류하여 60인 규모의 회사로 성장하는 과정에서 팀 리딩을 경험한 7년차 풀스택 개발자께서 개발 리드이자 사수로 계십니다.',
    },
    {
      dataKey: 'shouldStockOption',
      description:
        '초기에 합류해주시는 팀원들께는 그에 맞는 보상으로써 높은 수준의 스톡옵션을 지급해 드립니다.',
    },
  ],
  introPerson:
    '안녕하세요, 그룹바이 공동 창업자이자 채용을 담당하고 있는 COO Steve입니다.',
  proposeReason:
    '홍길동님의 프로필을 읽고, “비즈니스 임팩트를 만들어가는 Problem Solver”라는 정체성이 매우 인상 깊었습니다.\n최근에 공동 창업자로 도전하신 이력 등, 홍길동님께서 저희 팀에 딱 필요한 사람이라고 느껴 연락드리게 되었습니다.',
  appealPoints:
    '그룹바이는 국내 채용 시장의 흐름을 바꿀 스타트업으로, 실력 있는 인재가 가장 쉽고 빠르게 원하는 조건의 채용 제안을 받아볼 수 있는 서비스를 만들고 있습니다.\n채용 시장을 혁신하는 스타트업의 핵심 팀원으로서 중추적인 역할을 수행하는 경험은 물론, 짧은 기간 내 다른 조직과 비교할 수 없이 밀도 높은 성장과 커리어 점프를 약속드릴 수 있습니다.',
  outro:
    '그룹바이 채팅 또는 커피챗으로 저희 그룹바이와 저라는 사람을 더 자세히 소개해 드리고, 홍길동님과 대화 나눠보고 싶습니다.\n답장 주시기를 기다리겠습니다. 감사합니다!',
  positions: [],
  isResumeRequest: true,
}

export const StartupDetailForProposalGroupby: StartupDetailForProposal & {
  serviceAreas: string[] // TODO: 추후 api 수정하여 StartupDetailForProposal에 serviceAreas 추가해야 함
} = {
  id: 5,
  name: '그룹바이에이치알',
  thumbnail:
    'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/startups/5/1699855109/스크린샷 2023-11-10 오후 1.58.31.png',
  briefIntro:
    '나에게 딱 맞는 스타트업을 가장 쉽고 빠르게 만날 수 있는 채용 서비스를 만들고 있습니다.',
  serviceAreas: ['채용', 'B2B', 'B2B2C'],
  fundings: [
    { id: 39, round: 'Pre-A', amount: 10, attractedAt: '2024-05-16T00:00:00' },
  ],
  memberCount: 19,
  devCount: 6,
  hasCto: true,
  whatKindCompany:
    '<p>그룹바이는 “<strong>후보자 중심의 채용 시장</strong>"으로 변화되는 상황 속에서,</p><p>실력있는 인재가 <strong>가장 쉽고 빠르게 구직 조건에 딱 맞는 채용 제안을 받아볼 수 있는 서비스</strong>를 만들고 있습니다.</p><p><br></p><p>IT직종의 인재분들과 스타트업의 채용 문제를 해결하는 팀으로, 현재 그 어떤 경쟁사들보다 고객이 만족하는 서비스를 만들어가고 있습니다.</p>',
  curOutcome:
    '<p>스타트업과 IT 인재간의 <strong>채용 문제를 그 누구보다 잘 해결</strong>하고 있으며, 핵심 지표가 <strong>매월 130%씩 빠르게 성장</strong>하고 있습니다.</p><p><br></p><p>앞으로 그룹바이의 방향성과 현재까지의 성과를 인정받아 추가 투자 집행 문의가 계속해서 들어오고 있는 상황입니다.</p><p><br></p><p>21년 04월 | 그룹바이 창업</p><p>21년 08월 | KAIST E5 진출</p><p>21년 09월 | 5대 과학기술원 공동 창업 경진대회 본선 진출</p><p>22년 01월 | 그룹바이 플랫폼(MVP버젼) 출시</p><p>22년 04월 | Seed 투자유치 (Primer Sazze / 더벤처스)</p><p>22년 09월 | TIPS 정부지원사업 선정 (6억 규모)</p><p>23년 06월 ~ 12월 | 매 월 130% 지표 성장</p><p>24년 01월 ~ 03월 | Pre-A 10억 투자 유치</p>',
  reasonForInvesting:
    '<p><strong>프라이머사제</strong></p><p><strong>더벤처스</strong></p><p><em style="color: rgb(51, 51, 51);">"컴퓨터공학과 출신의 공동창업자들이 실제로 주니어 개발자의 취업과 관련한 문제를 직접 겪고 그 경험을 바탕으로 창업을 했다"</em></p><p><em style="color: rgb(51, 51, 51);">"풀고자 하는 시장 환경에 대한 이해도도 높고, 제품 개발을 위한 역량도 충분히 갖추고 있어 앞으로 이들이 스타트업의 개발자 채용 문제를 어떻게 풀어나갈지 매우 기대가 된다"</em></p>',
  images: [
    'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/startups/5/1706582136/Design2_1 (1).png',
    'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/startups/5/1706582136/1 오전 11.25.53.png',
    'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/startups/5/1706582136/스크린샷 2024-01-30 오전 11.13.21.png',
    'https://groupby-public-image.s3.ap-northeast-2.amazonaws.com/startups/5/1706582137/스크린샷 2024-01-30 오전 11.13.32.png',
  ],
  members: [
    {
      id: 12,
      name: '임진하',
      role: 'CEO',
      career: 'https://www.instagram.com/daily_groupby\n',
      intro:
        '그룹바이에서 CEO를 맡고 있는 임진하입니다. \nGIST 광주과학기술원 컴퓨터공학과 출신이고, 두 번의 창업경험으로 창업생태계와 비즈니스의 이해도를 키웠습니다.  \n창업생태계가 계속해서 커지고 개발자가 많아지는 시장의 흐름 속에서 개발자가 필요한 스타트업이 대기업만큼 채용을 잘 할 수 있는 미래를 그립니다.',
    },
    {
      id: 13,
      name: '박상민',
      role: 'COO',
      career: null,
      intro:
        '블루포인트파트너스 RA, GIST 광주과학기술원 컴퓨터공학과 출신으로 개발과 사업에 대한 이해가 높습니다. \n현재 그룹바이 Product팀의 PO와 COO를 맡고 있습니다. \n좋은 제품을 만들기 위해 끊임없이 성장하고 있으며, 개발자, 디자이너와 함께 시장에 큰 임팩트를 내기 위해 노력하고 있습니다.',
    },
    {
      id: 14,
      name: '고고',
      role: '개발리드',
      career: null,
      intro:
        '- 네이버, 디어코퍼레이션, 베어로보틱스에서 클라우드, iOS, 풀스택 개발 경험을 쌓으시고 두번의 프로젝트를 창업으로 이어나가셨습니다. \n주로 프론트엔드 개발을 리드하시고 현재는 백엔드 개발까지 담당하고 계신 리드개발자 이십니다. \n팀 내에 주니어 프론트엔드 개발자 2명과 백엔드 개발자 2명의 코드리뷰를 도와주시고, 제품과 협업의 방향성에 큰 도움을 주시고 계십니다.',
    },
  ],
}

export const TrackingHireStatusInfoMockData: TrackingHireStatusInfo[] = [
  {
    filterOption: {
      alertLevel: 1,
      isHide: false,
    },
    count: 12,
  },
  {
    filterOption: {
      alertLevel: 2,
      isHide: false,
    },
    count: 7,
  },
  {
    filterOption: {
      alertLevel: 3,
      isHide: false,
    },
    count: 4,
  },
  {
    filterOption: {
      alertLevel: null,
      isHide: true,
    },
    count: 2,
  },
]

export const TrackingHireStartupSimpleMockData: TrackingHireStartupSimple = {
  name: '그룹바이',
  isSigned: true,
  alertLevel: 1,
  alertReply: 'confirm',
  isHide: false,
  hasInProgress: true,
  lockElapsedDay: 4,
  lastActiveAt: '2024-07-02T14:22:44',
  memo: '채용 가능건 상당수 있음, 채팅 상태 업데이트 필요',
  chatStep: [
    {
      id: AdminMatchingListChatStatus.INPROGRESS,
      count: 4,
    },
    {
      id: AdminMatchingListChatStatus.CONTACTLATER,
      count: 1,
    },
    {
      id: AdminMatchingListChatStatus.INPROGRESS,
      count: 2,
    },
    {
      id: AdminMatchingListChatStatus.BREAKDOWN,
      count: 3,
    },
    {
      id: AdminMatchingListChatStatus.SUCCEEDED,
      count: 0,
    },
  ],
  hireCandidateStatus: [
    {
      id: 'TRACKING',
      count: 5,
    },
    {
      id: 'POSSIBLE',
      count: 2,
    },
    {
      id: 'IMPOSSIBLE',
      count: 3,
    },
    {
      id: 'HIRED',
      count: 0,
    },
  ],
}

export const ADMIN_FILES_MOCK_DATA: AdminFile[] = [
  // 익명화 처리 전
  {
    applicationFileId: 149,
    userFileId: null,
    anonymizedFileCreatedAt: null,
    anonymizedBy: null,
    anonymizedKey: null,
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: false,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: null,
    autoAnonymizedAt: null,
    isReviewed: null,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 바로 공개 (직접)
  {
    applicationFileId: 49,
    userFileId: null,
    anonymizedFileCreatedAt: null,
    anonymizedBy: '지경화',
    anonymizedKey: null,
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: true,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: null,
    autoAnonymizedAt: null,
    isReviewed: null,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 익명화 (직접)
  {
    applicationFileId: 249,
    userFileId: null,
    anonymizedFileCreatedAt: '2024-05-14T18:12:35.845796',
    anonymizedBy: '전슬기',
    anonymizedKey:
      'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: false,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: null,
    autoAnonymizedAt: null,
    isReviewed: null,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 익명화 대상 아님 (자동)
  {
    applicationFileId: 349,
    userFileId: null,
    anonymizedFileCreatedAt: null,
    anonymizedBy: 'system',
    anonymizedKey: null,
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: true,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: 'NOT_FOR_ANONYMIZATION',
    autoAnonymizedAt: '2024-05-14T18:12:35.845796',
    isReviewed: false,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 지원하지 않는 파일 (자동)
  {
    applicationFileId: 449,
    userFileId: null,
    anonymizedFileCreatedAt: null,
    anonymizedBy: 'system',
    anonymizedKey: null,
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: false,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: 'UNSUPPORTED_FILE_FORMAT',
    autoAnonymizedAt: '2024-05-14T18:12:35.845796',
    isReviewed: false,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 익명화 파일 생성 실패 (자동)
  {
    applicationFileId: 419,
    userFileId: null,
    anonymizedFileCreatedAt: null,
    anonymizedBy: 'system',
    anonymizedKey: null,
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: false,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: 'FILE_CREATION_FAILED',
    autoAnonymizedAt: '2024-05-14T18:12:35.845796',
    isReviewed: false,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
  // 익명화 성공 (자동)
  {
    applicationFileId: 429,
    userFileId: null,
    anonymizedFileCreatedAt: '2024-05-14T18:12:35.845796',
    anonymizedBy: 'system',
    anonymizedKey:
      'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    createdAt: '2024-05-14T16:38:35.845796',
    isNotForAnonymization: false,
    link: 'https://api.dev-groupby.biz/files/users/680/1715672315/인재프로필-전슬기-신입-2024-03-14-12-26-29.pdf',
    name: '전슬기일',
    autoAnonymizationResult: 'FILE_CREATED',
    autoAnonymizedAt: '2024-05-14T18:12:35.845796',
    isReviewed: false,
    reviewedBy: null,
    fileSystemVersion: 1,
  },
]

export const FilterAssessmentMockData: ScoutRequestFilterAssessment = {
  score: 42,
  sections: {
    isActivelySeeker: false,
    experience: true,
    careerServiceAreas: { total: 3, matched: 1 },
    techStacks: {
      total: 10,
      matched: 7,
    },
    salary: true,
  },
}

export const AdminBrokingRequestMockData: AdminBrokingRequests = {
  unhandled: [
    {
      id: 1,
      startup: { id: 1, name: 'SparkTech' },
      curationId: 1,
      curationName: 'AI Chatbot',
      user: {
        id: 1,
        name: '김철수',
        phone: '010-1324-2323',
        lastActiveAt: '2025-01-01',
      },
      meetingType: 'DELEGATED_MEET',
      dDay: 3,
      unreadMessages: 2,
      manager: { id: 1, name: '홍길동', image: null },
      remindMemo: '이번 주 안에 회의 자료 준비',
      userMemo: '자료 요청 일정 확인 필요',
      isPinned: true,
      pinnedAt: '2025-01-01T10:00:00Z',
      meetingInfo: {
        meetDate: '2025-02-01 14:00',
        timeMemo: '오후 3시',
        location: 'Zoom 회의',
        remark: '특이사항 없음',
      },
      reason: null,
      hiringProcess: null,
      createdAt: '2025-01-01T09:00:00Z',
      status: 'ACCEPTED',
      remindMeetingAt: '2025-01-01T09:00:00Z',
      hireTrackingMessageAt: '2025-01-01T09:00:00Z',
      proposalId: 1,
      scoutRequestId: 1,
      hiredAt: null,
      rejectedAt: null,
    },
  ],
  planningMeetings: [
    {
      id: 2,
      startup: { id: 2, name: 'GreenBreeze' },
      curationId: 2,
      curationName: '에코 플랫폼 검수',
      user: {
        id: 2,
        name: '이영희',
        phone: '010-1324-2323',
        lastActiveAt: '2025-01-20',
      },
      meetingType: 'DIRECT_MEET',
      dDay: 7,
      unreadMessages: 0,
      manager: { id: 2, name: '박준영', image: null },
      remindMemo: '회의 장소 변경 확인',
      userMemo: '지하철역 근처 주차 가능 여부 문의',
      isPinned: false,
      pinnedAt: '',
      meetingInfo: {
        meetDate: '2025-02-01 14:00',
        timeMemo: '오전 3시',
        location: '서울 강남구 테헤란로 123 빌딩 5층',
        remark: '거리두기 지침 확인',
      },
      reason: null,
      hiringProcess: null,
      createdAt: '2025-01-15T13:00:00Z',
      status: 'NOT_DECIDED',
      remindMeetingAt: '2025-01-01T09:00:00Z',
      hireTrackingMessageAt: '2025-01-01T09:00:00Z',
      proposalId: 1,
      scoutRequestId: 1,
      hiredAt: null,
      rejectedAt: null,
    },
  ],
  beforeMeetings: [
    {
      id: 3,
      startup: { id: 3, name: 'FoodieLab' },
      curationId: 3,
      curationName: '푸드테크 전략 세션',
      user: {
        id: 3,
        name: '박혜민',
        phone: '010-1324-2323',
        lastActiveAt: '2025-01-01',
      },

      meetingType: 'STARTUP_PROPOSE',
      dDay: 1,
      unreadMessages: 1,
      manager: { id: 3, name: '최민호', image: null },
      remindMemo: '시연 영상 준비 요청',
      userMemo: '레퍼런스 자료 공유받음',
      isPinned: false,
      pinnedAt: '',
      meetingInfo: {
        meetDate: '2025-02-01 14:00',
        timeMemo: '일요일 오전 1시',
        location: 'Google Meet',
        remark: '인터넷 연결 상태 확인',
      },
      reason: null,
      hiringProcess: null,
      createdAt: '2025-01-10T09:30:00Z',
      status: 'NOT_INTERESTED',
      remindMeetingAt: '2025-01-01T09:00:00Z',
      hireTrackingMessageAt: '2025-01-01T09:00:00Z',
      proposalId: 1,
      scoutRequestId: 1,
      hiredAt: null,
      rejectedAt: null,
    },
  ],
  afterMeetings: [
    {
      id: 4,
      startup: { id: 4, name: 'EduWorld' },
      curationId: 4,
      curationName: '온라인 학습 플랫폼',
      user: {
        id: 4,
        name: '김민지',
        phone: '010-1324-2323',
        lastActiveAt: '2025-01-01',
      },
      meetingType: 'DELEGATED_MEET',
      dDay: 0,
      unreadMessages: 0,
      manager: { id: 4, name: '신용석', image: null },
      remindMemo: '피드백 요약 정리 공유',
      userMemo: '추가 미팅 필요 여부 확인',
      isPinned: false,
      pinnedAt: '',
      meetingInfo: {
        meetDate: '2025-02-01 14:00',
        timeMemo: '새벽 1시',
        location: '서울역 회의실 B',
        remark: '없음',
      },
      reason: null,
      hiringProcess: null,
      createdAt: '2025-01-05T12:00:00Z',
      status: 'ACCEPTED',
      remindMeetingAt: '2025-01-01T09:00:00Z',
      hireTrackingMessageAt: '2025-01-01T09:00:00Z',
      proposalId: 1,
      scoutRequestId: 1,
      hiredAt: null,
      rejectedAt: null,
    },
  ],
}

export const AdminBrokingRequestConfirmedMockData: AdminBrokingRequestsConfirmed =
  {
    canceled: [
      {
        id: 1,
        startup: { id: 1, name: 'SparkTech' },
        curationId: 1,
        curationName: 'AI Chatbot',
        user: {
          id: 1,
          name: '김철수',
          phone: '010-1324-2323',
          lastActiveAt: '2025-01-01',
        },
        meetingType: 'DELEGATED_MEET',
        dDay: 3,
        unreadMessages: 2,
        manager: { id: 1, name: '홍길동', image: null },
        remindMemo: '이번 주 안에 회의 자료 준비',
        userMemo: '자료 요청 일정 확인 필요',
        isPinned: true,
        pinnedAt: '2025-01-01T10:00:00Z',
        meetingInfo: {
          meetDate: '2025-02-01 14:00',
          timeMemo: '오후 3시',
          location: 'Zoom 회의',
          remark: '특이사항 없음',
        },
        reason: null,
        hiringProcess: null,
        createdAt: '2025-01-01T09:00:00Z',
        status: 'ACCEPTED',
        remindMeetingAt: '2025-01-01T09:00:00Z',
        hireTrackingMessageAt: '2025-01-01T09:00:00Z',
        proposalId: 1,
        scoutRequestId: 1,
        hiredAt: null,
        rejectedAt: '2025-01-01T09:00:00Z',
      },
      {
        id: 2,
        startup: { id: 3, name: 'FoodieLab' },
        curationId: 2,
        curationName: '푸드테크 전략 세션',
        user: {
          id: 3,
          name: '박혜민',
          phone: '010-1324-2323',
          lastActiveAt: '2025-01-01',
        },
        meetingType: 'STARTUP_PROPOSE',
        dDay: 1,
        unreadMessages: 1,
        manager: { id: 3, name: '최민호', image: null },
        remindMemo: '시연 영상 준비 요청',
        userMemo: '레퍼런스 자료 공유받음',
        isPinned: false,
        pinnedAt: '',
        meetingInfo: {
          meetDate: '2025-02-01 14:00',
          timeMemo: '일요일 오전 1시',
          location: 'Google Meet',
          remark: '인터넷 연결 상태 확인',
        },
        reason: null,
        hiringProcess: null,
        createdAt: '2025-01-10T09:30:00Z',
        status: 'NOT_INTERESTED',
        remindMeetingAt: '2025-01-01T09:00:00Z',
        hireTrackingMessageAt: '2025-01-01T09:00:00Z',
        proposalId: 1,
        scoutRequestId: 1,
        hiredAt: null,
        rejectedAt: '2025-01-01T09:00:00Z',
      },
    ],
    accepted: [
      {
        id: 3,
        startup: { id: 2, name: 'GreenBreeze' },
        curationId: 3,
        curationName: '에코 플랫폼 검수',
        user: {
          id: 2,
          name: '이영희',
          phone: '010-1324-2323',
          lastActiveAt: '2025-01-20',
        },
        meetingType: 'DIRECT_MEET',
        dDay: 7,
        unreadMessages: 0,
        manager: { id: 2, name: '박준영', image: null },
        remindMemo: '회의 장소 변경 확인',
        userMemo: '지하철역 근처 주차 가능 여부 문의',
        isPinned: false,
        pinnedAt: '',
        meetingInfo: {
          meetDate: '2025-02-01 14:00',
          timeMemo: '오전 3시',
          location: '서울 강남구 테헤란로 123 빌딩 5층',
          remark: '거리두기 지침 확인',
        },
        reason: null,
        hiringProcess: null,
        createdAt: '2025-01-15T13:00:00Z',
        status: 'NOT_DECIDED',
        remindMeetingAt: '2025-01-01T09:00:00Z',
        hireTrackingMessageAt: '2025-01-01T09:00:00Z',
        proposalId: 1,
        scoutRequestId: 1,
        hiredAt: '2025-01-01T09:00:00Z',
        rejectedAt: null,
      },
      {
        id: 4,
        startup: { id: 4, name: 'EduWorld' },
        curationId: 4,
        curationName: '온라인 학습 플랫폼',
        user: {
          id: 4,
          name: '김민지',
          phone: '010-1324-2323',
          lastActiveAt: '2025-01-01',
        },
        meetingType: 'DELEGATED_MEET',
        dDay: 0,
        unreadMessages: 0,
        manager: { id: 4, name: '신용석', image: null },
        remindMemo: '피드백 요약 정리 공유',
        userMemo: '추가 미팅 필요 여부 확인',
        isPinned: false,
        pinnedAt: '',
        meetingInfo: {
          meetDate: '2025-02-01 14:00',
          timeMemo: '새벽 1시',
          location: '서울역 회의실 B',
          remark: '없음',
        },
        reason: null,
        hiringProcess: null,
        createdAt: '2025-01-05T12:00:00Z',
        status: 'LEFT_CHAT',
        remindMeetingAt: '2025-01-01T09:00:00Z',
        hireTrackingMessageAt: '2025-01-01T09:00:00Z',
        proposalId: 1,
        scoutRequestId: 1,
        hiredAt: '2025-01-01T09:00:00Z',
        rejectedAt: null,
      },
    ],
  }

export const AdminPreInterviewsMockData: AdminPreInterviewItem[] = [
  {
    id: 13,
    scoutRequestId: 172,
    user: { name: '전슬기', phone: '01092469214' },
    startup: { id: 213, name: '라틀라스', isPreInterviewContractSigned: false },
    questions: [
      {
        id: 14,
        content:
          '지금까지 만난 가장 어려운 문제는 무엇이고, 그 문제를 어떻게 해결했나요?',
        category: { id: 3, name: '문제 해결' },
      },
      {
        id: 13,
        content: '직전 회사에서 퇴사한 사유나 현재 이직하는 이유가 무엇인가요?',
        category: { id: 1, name: '동기부여' },
      },
      {
        id: 15,
        content: '궁극적으로 이루고자 하는 롱텀 비전이 무엇인가요?',
        category: { id: 4, name: '커리어' },
      },
      {
        id: 24,
        content:
          '지금까지 만난 가장 어려운 문제는 무엇이고, 그 문제를 어떻게 해결했나요?',
        category: { id: 6, name: '직접 입력' },
      },
    ],
    summary: '',
    videoLink: null,
    reportLink: null,
    requestedAt: '2025-02-13T12:33:24',
    resolvedAt: null,
    failedAt: '2025-02-13T12:33:24',
    failReason: '',
  },
  {
    id: 15,
    scoutRequestId: 209,
    user: { name: '민주', phone: '01012341234' },
    startup: { id: 212, name: 'Sonus', isPreInterviewContractSigned: false },
    questions: [
      {
        id: 14,
        content:
          '지금까지 만난 가장 어려운 문제는 무엇이고, 그 문제를 어떻게 해결했나요?',
        category: { id: 3, name: '문제 해결' },
      },
      {
        id: 13,
        content: '직전 회사에서 퇴사한 사유나 현재 이직하는 이유가 무엇인가요?',
        category: { id: 1, name: '동기부여' },
      },
      {
        id: 15,
        content: '궁극적으로 이루고자 하는 롱텀 비전이 무엇인가요?',
        category: { id: 4, name: '커리어' },
      },
      {
        id: 24,
        content:
          '지금까지 만난 가장 어려운 문제는 무엇이고, 그 문제를 어떻게 해결했나요?',
        category: { id: 6, name: '직접 입력' },
      },
    ],
    summary: '',
    videoLink: null,
    reportLink: null,
    requestedAt: '2025-02-13T12:33:24',
    resolvedAt: '2025-02-13T12:33:24',
    failedAt: null,
    failReason: '',
  },
]

export const PreInterviewMockData = {
  questions: [
    {
      id: '12',
      content: '이전 회사에서 어떤 성과를 달성하였나요?',
      category: {
        id: 1,
        name: '경험 성과',
      },
    },
  ],
  summary:
    '- 한 스타트업에서 4년 6개월 재직한 경험이 인상깊다.\n- PM/PO로써 커리어 방향이 명확하다.\n- 데이터 기반 의사결정에 익숙하고 해당 의사결정 방식을 매우 선호한다.\n아쉬운점\n- 최근 이직이 잦아 본인과 잘 맞는 회사를 오래 다닌다는 점을 고려해야한다.',
  videoLink: 'https://youtu.be/yOb7A1ECCag',
  reportLink:
    'https://docs.google.com/document/d/1CiTjq9HX5ObRTQuMKEXCRI4qlc1uFKDQ/edit?usp=sharing&ouid=102904790179402436383&rtpof=true&sd=true',
}
